<template>
  <div class="i-panel-item ui-layout-center">
    <slot />

    <div class="footer clearfix"
      role="region"
      :aria-label="LANG.multiactionToolbar">

      <slot name="footer" />
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['LANG']),
  },
};
</script>

<style scoped lang='scss'>
.i-panel-item {
  z-index: 3 !important;
}
.ui-layout-center {
  display: flex !important;
  flex-direction: column !important;
}
.footer {
  container-name: footer;
  container-type: inline-size;
}
</style>
